import { Component, OnInit } from '@angular/core';
import { ContextChange } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { InstructionPage } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';

@Component({
    selector: 'app-text-widget',
    templateUrl: './text-widget.component.html',
    styleUrls: ['./text-widget.component.scss'],
    standalone: false
})
export class TextWidgetComponent extends AbstractWidgetComponent implements OnInit {

  page = new InstructionPage({});

  constructor(private appServerAPI: AppServerAPI) {

    super();

  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    const contentFile = this.dashboardContext.getContextValue('dashboardConfiguration').contentFile;
    this.appServerAPI.get(contentFile)
        .subscribe(
          pageContent => {
            this.page = new InstructionPage(pageContent);
          }, error => {
            console.error('Failed to load ' + contentFile, error);
          }
        );
  }

}
